module.exports = __webpack_public_path__ + "static/media/webinar-privyid.473fe903.png";